// ready for code review

import type { Pinia, PiniaPluginContext } from 'pinia'
import type { NuxtApp } from '#app'
// import { authInterruption } from '@/utils/authInterruption'

export default defineNuxtPlugin((nuxtApp) => {
    // Destructuring with a type assertion for $pinia (optional, but good for clarity)
    const { $pinia } = nuxtApp as NuxtApp & { $pinia: Pinia }

    if (!$pinia) {
        // console.warn(
        //     'Pinia instance not found. Pinia action subscriber plugin might not work correctly.'
        // )
        return
    }
    const errorRecoveryStore = useErrorRecoveryStore($pinia)
    // Use the store definition to get its instance from the piniaInstance
    const { authFlowView } = useAuthFlow()
    // Use Pinia's plugin system to tap into every store as it's created
    $pinia.use(({ store }: PiniaPluginContext) => {
        // Attach the $onAction listener to each store instance
        store.$onAction(({ name, after, onError, args }) => {
            if (store.inProgress) {
                store.inProgress = true
            }

            // Register callbacks for after success or error
            after(() => {
                if (store.inProgress) {
                    store.inProgress = false
                }
            })
            // incomplete code
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onError((error: any) => {
                if (store.inProgress) {
                    store.inProgress = false
                }
                if (authFlowView.value !== 'login') {
                    errorRecoveryStore.addFailedLog({ store, name, args, error })
                }

                // if (error.statusCode && error.statusCode === 401) {
                //     //     // set current url in localstorage
                //     //  authInterruption()
                //     //     // Call the action on the Pinia store to open the sign in modal.
                //     //  open('login')
                // } else {
                //     if (!userAuthStore.isSignInModalOpen) {
                //         //     // Call the action on the Pinia store to open the sign in modal.
                //         //  errorRecoveryStore.setErrorRecoveryModalVisibility(true)
                //    }
                // }
                errorRecoveryStore.trackWithDatadog(error)
            })
        })
    })

    // userAuthStore.$onAction(({ name, args, onError, store: currentStoreInstance }) => {
    //     // Register callbacks for after success or error
    //     // after((result) => {
    //     //     // This runs if the action completes successfully
    //     // })

    //     onError((error: any) => {
    //         if (error.statusCode && error.statusCode === 401) {
    //             //     // set current url in localstorage
    //             authInterruption()
    //             //     // Call the action on the Pinia store to open the sign in modal.
    //             userAuthStore.setSignInModalVisibility(true)
    //         }
    //     })
    // })
})
